<template>
  <div class="d-flex">
    <v-card flat outlined class="ma-0 pa-0 mr-1">
      <v-card-title
        class="ma-0 pa-0 px-1 caption font-weight-normal justify-center grey lighten-4 grey--text"
        ><div class="headerClass">
          {{ $t("fabricTextOutlineGroupControlsTitle") }}
        </div></v-card-title
      >
      <v-card-actions class="ma-0 pa-0 px-1">
        <v-spacer></v-spacer>

        <!-- GUMB SPREMENI VELIKOST OKVIRJA -->
        <div>
          <v-menu :close-on-content-click="true">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                text
                middle
                color="accent"
                class="mx-1 elevation-0"
                style="min-width: 16px; width: 16px"
              >
                <span style="text-color: 505050"
                  >{{ simpleFrameBorderSettings.borderWidth }}
                </span>
              </v-btn>
            </template>
            <v-card class="pa-4">
              <v-card-text class="pa-0">
                <v-slider
                  v-model="simpleFrameBorderSettings.borderWidth"
                  class="align-center"
                  :max="100"
                  :min="0"
                  hide-details
                  vertical
                  @change="formatBorderWidth()"
                ></v-slider>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>

        <!-- GUMB SPREMENI BARVO OKVIRJA -->
        <div>
          <v-menu :close-on-content-click="true">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                text
                middle
                color="accent"
                class="elevation-0"
                style="min-width: 16px; width: 16px"
              >
                <v-icon
                  :color="simpleFrameBorderSettings.borderColor"
                  style="border: 1px solid silver"
                  >mdi-square</v-icon
                >
              </v-btn>
            </template>
            <v-card>
              <v-card-text class="pa-0">
                <v-color-picker
                  flat
                  :hide-mode-switch="true"
                  show-swatches
                  hide-canvas
                  hide-inputs
                  :dot-size="20"
                  :swatches-max-height="$vuetify.breakpoint.height / 1.5"
                  v-model="simpleFrameBorderSettings.borderColor"
                  @input="formatBorderColor()"
                />
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <v-card v-if="simpleFrameRect" flat outlined class="ma-0 pa-0 mr-1">
      <v-card-title
        class="ma-0 pa-0 px-1 caption font-weight-normal justify-center grey lighten-4 grey--text"
        ><div class="headerClass">
          {{ $t("fabricRadiusGroupControlsTitle") }}
        </div></v-card-title
      >
      <v-card-actions class="ma-0 pa-0 px-1">
        <v-spacer></v-spacer>
        <!-- GUMB SPREMENI ZAOBLJENOST OKVIRJA -->
        <div>
          <v-menu :close-on-content-click="true">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                text
                middle
                color="accent"
                class="mx-1 elevation-0"
                style="min-width: 16px; width: 16px"
              >
                <span style="text-color: 505050"
                  >{{ simpleFrameBorderSettings.borderRadius }}
                </span>
              </v-btn>
            </template>
            <v-card class="pa-4">
              <v-card-text class="pa-0">
                <v-slider
                  v-model="simpleFrameBorderSettings.borderRadius"
                  class="align-center"
                  :max="50"
                  :min="0"
                  hide-details
                  vertical
                  @change="formatBorderRadius()"
                ></v-slider>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <v-card flat outlined class="ma-0 pa-0 mr-1">
      <v-card-title
        class="ma-0 pa-0 px-1 caption font-weight-normal justify-center grey lighten-4 grey--text"
        ><div class="headerClass">
          {{ $t("fabricSimpleFrameGroupControlsTitle") }}
        </div></v-card-title
      >
      <v-card-actions class="ma-0 pa-0 px-1">
        <v-spacer></v-spacer>
        <!-- GUMB RESET OKVIRJA -->
        <v-btn
          text
          middle
          color="accent"
          class="mx-1 elevation-0"
          style="min-width: 16px; width: 16px"
          @click="resetSimpleFrame()"
        >
          <v-icon>mdi-square-off-outline</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "fabric-simple-frame-controls-card",
  props: {
    template: {
      type: Object,
      required: true,
    },
    simpleFrameRect: {
      type: Boolean,
      required: true,
    },
    frame: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    formatBorderWidth() {
      if (this.frame) {
        if (this.simpleFrameRect) {
          this.template.canvas
            .getActiveObject()
            .item(0)
            .set({
              width:
                this.template.canvas.getActiveObject().item(1).width +
                this.simpleFrameBorderSettings.borderWidth * 2,
              height:
                this.template.canvas.getActiveObject().item(1).height +
                this.simpleFrameBorderSettings.borderWidth * 2,
            })
            .setCoords();
          this.template.canvas
            .getActiveObject()
            .item(0)
            .set(
              "height",
              this.template.canvas.getActiveObject().item(1).height +
                this.simpleFrameBorderSettings.borderWidth * 2
            );
        } else {
          this.template.canvas
            .getActiveObject()
            .item(0)
            .set({
              rx:
                this.template.canvas.getActiveObject().item(1).clipPath.rx +
                this.simpleFrameBorderSettings.borderWidth,
              ry:
                this.template.canvas.getActiveObject().item(1).clipPath.ry +
                this.simpleFrameBorderSettings.borderWidth,
            })
            .setCoords();
        }
      } else
        this.template.canvas
          .getActiveObject()
          .set("strokeWidth", this.simpleFrameBorderSettings.borderWidth);
      this.template.canvas.requestRenderAll();
    },
    formatBorderRadius() {
      if (this.frame) {
        this.template.canvas
          .getActiveObject()
          .item(0)
          .set("rx", this.simpleFrameBorderSettings.borderRadius);
        this.template.canvas
          .getActiveObject()
          .item(0)
          .set("ry", this.simpleFrameBorderSettings.borderRadius);
      } else {
        this.template.canvas
          .getActiveObject()
          .set("rx", this.simpleFrameBorderSettings.borderRadius);
        this.template.canvas
          .getActiveObject()
          .set("ry", this.simpleFrameBorderSettings.borderRadius);
      }
      this.template.canvas.requestRenderAll();
    },
    formatBorderColor() {
      if (this.frame) {
        this.template.canvas
          .getActiveObject()
          .item(0)
          .set("fill", this.simpleFrameBorderSettings.borderColor);
      } else
        this.template.canvas
          .getActiveObject()
          .set("stroke", this.simpleFrameBorderSettings.borderColor);

      this.template.canvas.requestRenderAll();
    },
    resetSimpleFrame() {
      if (this.frame) {
        if (this.simpleFrameRect) {
          this.template.canvas
            .getActiveObject()
            .item(0)
            .set("width", this.template.canvas.getActiveObject().item(1).width);
          this.template.canvas
            .getActiveObject()
            .item(0)
            .set(
              "height",
              this.template.canvas.getActiveObject().item(1).height
            );
        } else {
          this.template.canvas
            .getActiveObject()
            .item(0)
            .set("rx", this.template.canvas.getActiveObject().item(1).rx);
          this.template.canvas
            .getActiveObject()
            .item(0)
            .set("ry", this.template.canvas.getActiveObject().item(1).ry);
        }
      } else {
        this.template.canvas.getActiveObject().set("stroke", "#FFFFFFFF");
        this.template.canvas.getActiveObject().set("strokeWidth", 0);

        if (this.simpleFrameRect) {
          this.template.canvas.getActiveObject().set("rx", 0);
          this.template.canvas.getActiveObject().set("ry", 0);
        }
      }

      this.template.canvas.requestRenderAll();
    },
  },
};
</script>

<style scoped>
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
}
.hover-item {
  cursor: pointer;
}
</style>